"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Clock, TriangleAlert, ShieldAlert, FileText, PenTool } from "lucide-react";
const faqs = [{
  id: "item-1",
  question: "HOW DO I PAY THE REMAINING BALANCE?",
  answer: "We require a deposit at the time of booking via our secured PayPal link. The remaining balance for your stay at Paradise Palms is settled upon your arrival in Montego Bay. We accept USD and major credit cards at our 24-hour front desk.",
  iconName: "FileText"
}, {
  id: "item-2",
  question: "WHAT IS THE CHECK-IN TIME?",
  answer: "Standard check-in is at 3:00 PM and check-out is at 11:00 AM. Please let us know your flight details so we can coordinate your airport pick-up. Early check-in may be available depending on previous guest departures.",
  iconName: "Clock"
}, {
  id: "item-3",
  question: "ARE CHILDREN ALLOWED AT THE PROPERTY?",
  answer: "Absolutely! Paradise Palms is a family-friendly vacation rental. Our booking form includes a specific field for the number of children joining your group. The property sleeps 9 guests comfortably across 4 bedrooms.",
  iconName: "ShieldAlert"
}, {
  id: "item-4",
  question: "DO YOU PROVIDE TRANSPORTATION?",
  answer: "Yes, we offer convenient airport pick-up and drop-off services for all guests. We also provide a shuttle service to the local beach for just $10 USD per trip, ensuring you can enjoy the Jamaican sun without any hassle.",
  iconName: "TriangleAlert"
}, {
  id: "item-5",
  question: "WHAT IS THE CANCELLATION POLICY?",
  answer: "We understand plans change. Cancellations made well in advance are eligible for a partial refund of the deposit. Please visit our dedicated Policy page for the full breakdown of timelines and terms regarding your reservation.",
  iconName: "PenTool"
}];
const getIcon = (name: string) => {
  switch (name) {
    case "Clock":
      return <Clock className="size-6 text-primary shrink-0" />;
    case "TriangleAlert":
      return <TriangleAlert className="size-6 text-primary shrink-0" />;
    case "ShieldAlert":
      return <ShieldAlert className="size-6 text-primary shrink-0" />;
    case "FileText":
      return <FileText className="size-6 text-muted-foreground shrink-0" />;
    case "PenTool":
      return <PenTool className="size-6 text-muted-foreground shrink-0" />;
    default:
      return <TriangleAlert className="size-6 text-primary shrink-0" />;
  }
};
export default function TheFinePrint() {
  return <section data-section-id="101503" id="common-questions" className="bg-background text-foreground py-24 px-6 sm:px-8 lg:px-12 relative border-t border-border/20">
      {}
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none bg-[radial-gradient(circle_at_center,var(--color-primary)_1px,transparent_1px)] bg-[size:32px_32px]"></div>

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="mb-16 text-center">
          <h2 className="text-4xl md:text-6xl font-bold tracking-tighter uppercase text-primary mb-4 font-sans">
            Common Questions
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto font-sans uppercase tracking-widest">
            Planning Your Jamaican Escape
          </p>
        </div>

        <div className="border-y border-primary/10 bg-card/50 backdrop-blur-md rounded-3xl overflow-hidden shadow-xl">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => <AccordionItem key={faq.id} value={faq.id} data-index={index} className="border-b border-border/50 last:border-b-0 data-[state=open]:bg-accent/30 transition-colors duration-300 px-4 md:px-8">
                <AccordionTrigger className="font-sans font-bold text-base md:text-xl py-6 hover:text-primary hover:no-underline [&[data-state=open]]:text-primary gap-6 text-left">
                  <div className="flex items-center gap-4 flex-1">
                    {getIcon(faq.iconName)}
                    <span className="tracking-tight">{faq.question}</span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base md:text-lg leading-relaxed pb-8 pt-2 pl-14 md:pl-16 pr-4 font-sans">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
        
        {}
        <div className="h-2 w-full mt-12 bg-[repeating-linear-gradient(45deg,var(--color-primary)_0,var(--color-primary)_10px,transparent_10px,transparent_20px)] opacity-10"></div>
      </div>
    </section>;
}